<template>
  <header id="header">
    <HeaderTop />
    <HeaderMiddle />
    <HeaderMenu />
  </header>
</template>

<script>
import HeaderTop from '@/components/header/HeaderTop'
import HeaderMiddle from '@/components/header/HeaderMiddle'
import HeaderMenu from '@/components/header/HeaderMenu'

export default {
  name: 'Header',
  components: {
    HeaderTop,
    HeaderMiddle,
    HeaderMenu,
  },
}
</script>

<style></style>
